// extracted by mini-css-extract-plugin
export default {"Banner":"styles_Banner__5g-Jn","container":"styles_container__yt+J8"};